import { render, staticRenderFns } from "./TopfansScene.vue?vue&type=template&id=16f14dd8&scoped=true&"
import script from "./TopfansScene.vue?vue&type=script&lang=js&"
export * from "./TopfansScene.vue?vue&type=script&lang=js&"
import style0 from "./TopfansScene.vue?vue&type=style&index=0&id=16f14dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f14dd8",
  null
  
)

export default component.exports